import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./navbar.css";
import { NavigationItem } from "../../routes/navigationConfig";
import { useAppContext } from "../../../contexts/AppContext";

interface NavBarProps {
    navigation: NavigationItem[];
}

const NavBar: React.FC<NavBarProps> = ({ navigation }) => {
    const navigate = useNavigate();
    const { user } = useAppContext();
    const [open, setOpen] = React.useState(false);
    const [dropdown, setDropdown] = React.useState(false);
    const [scrolling, setScrolling] = useState(false);
    const [subItem, setSubItem] = useState(false)
    const [subItem2, setSubItem2] = useState(false)
    const location = useLocation();

    const handleDropdown = () => {
        setDropdown(!dropdown);
    }

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > (location.pathname === '/' ? 100 : 50)) {
                setScrolling(true);
            } else {
                setScrolling(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location.pathname]);

    const handleOpen = () => {
        if (open) {
            // If the menu is open, close it with animation
            const mobileMenuBg = document.getElementById('mobile-menu-bg');
            const mobileMenu = document.getElementById('mobile-menu');
            if (mobileMenuBg && mobileMenu) {
                mobileMenu.classList.remove('slide-in-left');
                mobileMenu.classList.add('slide-out-left');
                setTimeout(() => {
                    setOpen(false);
                }, 600); // Animation duration
            }
        } else {
            // If the menu is closed, open it
            setOpen(true);
        }
    }


    const handleSubItem = () => {
        setSubItem(!subItem)
    }

    const handleSubItem2 = () => {
        setSubItem2(!subItem2)
    }

    const navigateToProfile = () => {
        if (user) {
            if (user.role === Number(process.env.REACT_APP_SUPER_ADMIN) || user.role === Number(process.env.REACT_APP_ADMIN)) {
                navigate("/admin-profile");
            } else {
                navigate("/profile");
            }
        }
    }

    // outside click dropdown close dropdownMenu
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const dropdownMenu = document.getElementById('dropdownMenu');
            const dropdownMenuButton = document.getElementById('dropdownMenuButton');
            if (dropdownMenu && dropdownMenuButton) {
                if (!dropdownMenu.contains(event.target as Node) && !dropdownMenuButton.contains(event.target as Node)) {
                    setDropdown(false);
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdown]);

    return (
        <>

            <nav
                className={`fixed w-full transition-colors z-[99] duration-300
              ${scrolling ? 'bg-primaryColor' : location.pathname === '/' ? 'bg-transparent' : 'bg-primaryColor'}
              `}
            >
                <div className="px-5 md:px-10">
                    <div className="flex items-center justify-between py-5 lg:py-5">
                        {open ? <div className="flex-shrink-0">

                        </div>
                            :
                            <div className="flex lg:hidden z-[99999]">
                                <button
                                    type="button"
                                    className="p-2 text-[22px] rounded-md text-white hover:text-secondaryColor bg-primaryColor focus:outline-none"
                                    onClick={handleOpen}
                                >
                                    <svg viewBox="64 64 896 896" focusable="false" data-icon="menu" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"></path></svg>
                                </button>
                            </div>
                        }
                        <div className="flex-shrink-0 hidden lg:block">
                            <Link to="/">
                                <img
                                    className="h-[25px]"
                                    src="assets/images/logo/logo-yellow.svg"
                                    alt="Workflow"
                                />
                            </Link>
                        </div>
                        <div className="hidden lg:block">
                            <ul className="flex space-x-4">
                                {navigation.map((item, index) => (
                                    <li key={index}>
                                        {item.type === 'link' ?
                                            <Link
                                                to={String(item.path)}
                                                className={`
                                    hover:text-secondaryColor px-3 py-2 flex items-center gap-2 rounded-md text-[14px] capitalize whitespace-nowrap
                                    ${location.pathname === item.path ? 'text-secondaryColor font-bold' : 'text-white font-medium'}
                                    `}
                                            >
                                                {/* {item.icon &&  <i className={`fas fa-${item.icon}`}></i>  } */}
                                                {item.title}
                                                {String(item.type) === 'group' ? <i className="fas fa-chevron-down"></i> : ''}
                                            </Link>
                                            :
                                            <div className="dropdown-1">
                                                {item.path ?
                                                    <Link
                                                        to={String(item.path)}
                                                        className="hover:text-secondaryColor px-3 py-2 flex items-center gap-2 rounded-md text-[14px] uppercase text-white font-bold"
                                                    >
                                                        {item.title}
                                                        <i className="fas fa-chevron-down"></i>
                                                    </Link>
                                                    :
                                                    <button
                                                        type="button"
                                                        className="hover:text-secondaryColor px-3 py-2 flex items-center gap-2 rounded-md text-[14px] uppercase text-white font-bold"
                                                    >
                                                        {item.title}
                                                        <i className="fas fa-chevron-down"></i>
                                                    </button>
                                                }
                                                <ul className="absolute  dropdown-content-1 bg-gray-800 text-white">
                                                    {item.children?.map((child, index) => (
                                                        <li key={index} className="hover:text-primaryColor hover:bg-secondaryColor">
                                                            {child.type === 'link' ?
                                                                <Link
                                                                    to={String(child.path)}
                                                                    className={`px-5 py-2 flex items-center gap-2 text-[14px] uppercase font-bold transition-all duration-300 hover:translate-x-2`}
                                                                >
                                                                    {child.title}
                                                                </Link>
                                                                :
                                                                <div className="dropdown-2">
                                                                    {child.path ?
                                                                        <Link
                                                                            to={String(child.path)}
                                                                            className="px-5 py-2 flex items-center gap-2 text-[14px] uppercase font-bold transition-all duration-300 hover:translate-x-2"
                                                                        >
                                                                            {child.title}
                                                                            <i className="fas fa-chevron-down"></i>
                                                                        </Link>
                                                                        :
                                                                        <button
                                                                            type="button"
                                                                            className="px-5 py-2 flex items-center gap-2 text-[14px] uppercase font-bold transition-all duration-300 hover:translate-x-2"
                                                                        >
                                                                            {child.title}
                                                                            <i className="fas fa-chevron-down"></i>
                                                                        </button>
                                                                    }
                                                                    <ul className="absolute dropdown-content-2 bg-gray-800 text-white">
                                                                        {child.children?.map((subChild, index) => (
                                                                            <li key={index} className="hover:text-primaryColor hover:bg-secondaryColor">
                                                                                <Link
                                                                                    to={String(subChild.path)}
                                                                                    className={`px-5 py-2 flex items-center gap-2 text-[14px] uppercase font-bold transition-all duration-300 hover:translate-x-2`}
                                                                                >
                                                                                    {subChild.title}
                                                                                </Link>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </div>
                                                            }
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        }
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {localStorage.getItem('accessToken') ? (
                            <div className="flex items-center gap-4">
                                {(user?.role === Number(process.env.REACT_APP_SUPER_ADMIN) || user?.role === Number(process.env.REACT_APP_ADMIN)) && (
                                    <Link
                                        to="/dashboard"
                                        className="text-white text-[14px] hover:text-secondaryColor px-3 py-2 cursor-pointer rounded-md "
                                    >
                                        <i className="fas fa-tachometer-alt"></i>
                                    </Link>
                                )}
                                <div
                                    className="flex items-center gap-2 group cursor-pointer relative"
                                    onClick={handleDropdown}
                                >
                                    <div className="flex-shrink-0 w-[40px] h-[40px] rounded-full overflow-hidden">
                                        <img
                                            className="w-full h-full rounded-full object-cover"
                                            src="https://images.ctfassets.net/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&fl=progressive&q=70&fm=jpg"
                                            alt="Workflow"
                                        />
                                    </div>
                                    <div className="tracking-wide hidden xl:block">
                                        <h3 className="text-white text-[14px] group-hover:text-secondaryColor">
                                            {user?.first_name} {user?.last_name}
                                        </h3>
                                    </div>
                                    <button
                                        type="button"
                                        className="text-white text-[16px] group-hover:text-secondaryColor px-1 py-2 rounded-md hidden xl:block"
                                        id="dropdownMenuButton"
                                    >
                                        <i className="fas fa-chevron-down"></i>
                                    </button>
                                    {dropdown && (
                                        <div
                                            id="dropdownMenu"
                                            className="absolute bg-[#0000008a] top-12 right-0 w-[200px] xl:w-[100%] text-white rounded-md shadow-lg transition-all duration-300 ease-in-out overflow-hidden"
                                            style={{
                                                backdropFilter: 'blur(15px)',
                                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                            }}
                                        >
                                            <button
                                                type="button"
                                                onClick={navigateToProfile}
                                                className="px-4 py-2 w-full flex justify-start items-center hover:text-primaryColor hover:bg-secondaryColor transition-all duration-300"
                                            >
                                                <i className="fas fa-user mr-2"></i> Profile
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    localStorage.removeItem("accessToken");
                                                    localStorage.clear();
                                                    window.location.href = "/#/login";
                                                }}
                                                className="block w-full text-left px-4 py-2 hover:text-primaryColor hover:bg-secondaryColor transition-all duration-300"
                                            >
                                                <i className="fas fa-sign-out-alt mr-2"></i> Logout
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="flex items-center gap-4">
                                <Link
                                    to="/login"
                                    className="text-white text-[14px] hover:text-secondaryColor px-3 py-2 rounded-md "
                                >
                                    Login
                                </Link>
                                <Link
                                    to="/register"
                                    className="text-white text-[14px] hover:text-secondaryColor px-3 py-2 rounded-md "
                                >
                                    Sign Up
                                </Link>

                            </div>
                        )}


                    </div>
                </div>
            </nav>
            <nav className={`fixed  bg-[#0000008a] w-full ${open ? 'h-full z-[999]' : 'z-[99]'}`} onClick={handleOpen}>
                <div className={`${open ? 'absolute block z-[9999] top-0 bottom-0 left-0 max-w-[75%] w-[400px] bg-primaryColor mobile-menu slide-in-left' : 'hidden slide-out-left'} lg:hidden`} id="mobile-menu">
                    <div className={`${open ? 'absolute block z-[9999] right-0 left-0 transition-opacity' : 'hidden'} lg:hidden`} id="mobile-menu-bg">
                        <div className="lg:hidden absolute top-2 right-2 p-2">
                            <button
                                type="button"
                                className="inline-flex items-center justify-center p-2 rounded-md hover:text-primaryColor text-secondaryColor hover:bg-secondaryColor bg-primaryColor hover:fill-slate-950 duration-300 transition-all border border-secondaryColor focus:outline-none"
                                onClick={handleOpen}
                            >
                                <svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"></path></svg>
                            </button>
                        </div>
                    </div>
                    <div className="w-full h-full float-end bg-menuBarImage bg-cover bg-center bg-no-repeat">
                        <Link className="flex items-center justify-center" to="/">
                            <img
                                className="w-[220px] py-10"
                                src="assets/images/logo/logo-new.png"
                                alt="Workflow"
                            />
                        </Link>
                        <div className="pt-2 pb-3">
                            {navigation.map((item, index) => (
                                <div key={index} className={`border-[#9999999c] ${index === 0 ? 'border-y-[1.5px]' : 'border-b-[1.5px]'} `}>
                                    {item.type === 'link' ?
                                        <Link
                                            to={String(item.path)}
                                            className={`
                                    hover:text-primaryColor hover:bg-secondaryColor px-3 py-2 flex items-center gap-2 text-[14px] uppercase 
                                    ${location.pathname === item.path ? 'text-primaryColor font-extrabold bg-secondaryColor' : 'text-white font-bold'}
                                    `}
                                        >
                                            {/* {item.icon &&  <i className={`fas fa-${item.icon}`}></i>  } */}
                                            {item.title}
                                            {String(item.type) === 'group' ? <i className="fas fa-chevron-down"></i> : ''}
                                        </Link>
                                        :
                                        <div>
                                            {item.path ?
                                                <div
                                                    className={`flex items-center justify-between w-full text-[14px] uppercase  font-bold ${subItem ? 'bg-[#f6b53ce5]' : 'text-white'}`}
                                                >
                                                    <Link
                                                        to={String(item.path)}
                                                        className="pl-3 py-2 hover:text-primaryColor hover:bg-secondaryColor text-white w-full cursor-pointer"
                                                    >
                                                        {item.title}
                                                    </Link>
                                                    <button
                                                        type="button"
                                                        onClick={handleSubItem}
                                                        className="px-4 py-2 border-x-[1.5px] border-[#9999999c] text-white hover:text-primaryColor hover:bg-secondaryColor cursor-pointer"
                                                    >
                                                        <i className="fas fa-chevron-down"></i>
                                                    </button>
                                                </div>
                                                :
                                                <button
                                                    type="button"
                                                    onClick={handleSubItem}
                                                    className={`flex pl-3 py-2 items-center justify-between w-full text-[14px] hover:text-primaryColor hover:bg-secondaryColor text-white cursor-pointer uppercase  font-bold ${subItem ? 'bg-[#f6b53ce5]' : 'text-white'}`}
                                                >
                                                    <span className="transition-all duration-300 hover:translate-x-2 flex w-full ">
                                                        {item.title}
                                                    </span>
                                                    <div className="px-4">
                                                        <i className="fas fa-chevron-down"></i>
                                                    </div>
                                                </button>
                                            }
                                            {subItem &&
                                                <ul>
                                                    {item.children?.map((child, index) => (
                                                        <li key={index} className={`border-[#f819199c] ${index === 0 ? 'border-y-[1.5px]' : 'border-b-[1.5px]'}`}>
                                                            {child.type === 'link' ?
                                                                <Link
                                                                    to={String(child.path)}
                                                                    className={`px-5 py-2 flex items-center gap-2 text-[14px] uppercase font-bold transition-all duration-300 hover:translate-x-2`}
                                                                >
                                                                    {child.title}
                                                                </Link>
                                                                :
                                                                <div>
                                                                    {child.path ?
                                                                        <div
                                                                            className={`flex items-center justify-between w-full text-[14px] uppercase  font-bold ${subItem2 ? 'bg-[#f6b53cb6]' : 'text-white'} `}
                                                                        >
                                                                            <Link
                                                                                to={String(child.path)}
                                                                                className="hover:text-primaryColor hover:bg-secondaryColor text-white w-full cursor-pointer"
                                                                            >
                                                                                <span className="pl-5 py-2 transition-all duration-300 hover:translate-x-2 flex w-full ">

                                                                                    {child.title}
                                                                                </span>
                                                                            </Link>
                                                                            <button
                                                                                type="button"
                                                                                onClick={handleSubItem2}
                                                                                className="px-4 py-2 border-x-[1.5px] border-[#999] text-white hover:text-primaryColor cursor-pointer"
                                                                            >
                                                                                <i className="fas fa-chevron-down"></i>
                                                                            </button>
                                                                        </div>
                                                                        :
                                                                        <button
                                                                            type="button"
                                                                            onClick={handleSubItem2}
                                                                            className={`flex pl-5 py-2 items-center justify-between w-full text-[14px] hover:text-primaryColor hover:bg-secondaryColor text-white cursor-pointer uppercase  font-bold ${subItem2 ? 'bg-[#f6b53cb6]' : 'text-white'}`}
                                                                        >
                                                                            <span className="transition-all duration-300 hover:translate-x-2 flex w-full ">
                                                                                {child.title}
                                                                            </span>
                                                                            <div className="px-4">
                                                                                <i className="fas fa-chevron-down"></i>
                                                                            </div>
                                                                        </button>
                                                                    }
                                                                    {subItem2 &&
                                                                        <ul className=" text-white">
                                                                            {child.children?.map((subChild, index) => (
                                                                                <li key={index} className="hover:text-primaryColor hover:bg-[#f6b53c71]">
                                                                                    <Link
                                                                                        to={String(subChild.path)}
                                                                                        className={`px-8 py-2 flex items-center gap-2 text-[14px] uppercase font-bold transition-all duration-300 hover:translate-x-2`}
                                                                                    >
                                                                                        {subChild.title}
                                                                                    </Link>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    }
                                                                </div>
                                                            }
                                                        </li>
                                                    ))}
                                                </ul>
                                            }
                                        </div>
                                    }
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </nav>

        </>

    );
}

export default NavBar;
